var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", { staticClass: "header-item" }, [
          _vm._v("Push Notification Data"),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "card-content" }, [
      _vm.status === "not-loading"
        ? _c("div", [
            _c(
              "div",
              { staticStyle: { "text-align": "center", margin: "40px" } },
              [
                _c(
                  "a",
                  {
                    staticClass: "el-button el-button--primary",
                    on: {
                      click: function ($event) {
                        return _vm.loadLogs()
                      },
                    },
                  },
                  [
                    _vm._v("\n          Load Push Notification Logs "),
                    _c("i", { staticClass: "el-icon-download" }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { "text-align": "center" } }, [
                  _c("small", [_vm._v("This request may take a while")]),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.status === "loading"
        ? _c("div", { staticClass: "message" }, [
            _c(
              "div",
              { staticStyle: { "text-align": "center", margin: "40px" } },
              [
                _vm._v(
                  "\n        Loading Push Notification Logs. Please stay at this page without reloading it. "
                ),
                _c("i", { staticClass: "el-icon-loading" }),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.status === "loaded"
        ? _c("div", [
            _vm.pnsData.length < 1
              ? _c("div", { staticClass: "message" }, [
                  _vm._v(
                    "\n        Push notifications not found for this event.\n      "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pnsData.length > 0
              ? _c(
                  "div",
                  _vm._l(_vm.pnsData, function (row) {
                    return _c(
                      "div",
                      { key: row },
                      _vm._l(row.metadata, function (meta) {
                        return _c(
                          "el-card",
                          { key: meta, staticClass: "box-card" },
                          [
                            _c(
                              "ul",
                              _vm._l(meta, function (key, value) {
                                return _c("li", { key: key }, [
                                  _c("strong", [_vm._v(_vm._s(value) + ": ")]),
                                  _vm._v(_vm._s(key) + "\n              "),
                                ])
                              }),
                              0
                            ),
                          ]
                        )
                      }),
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }